import {
  Sprite,
  SpriteMaterial,
  TextureLoader,
  Vector3,
  Group,
  WebGLRenderer,
  Camera,
  OrthographicCamera,
  Scene,
  CylinderGeometry,
  Mesh,
  MeshBasicMaterial,
  Box3,
  LinearFilter,
} from "three";
import { Font } from "three/examples/jsm/loaders/FontLoader";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";
import font from "../../../fonts/RoundedMplus1c_Regular.json";
import { PICKPOINT_TEXT_HEIGHT, PICKPOINT_TEXT_SIZE } from "../config/ViewerConfig";
import { PerspectiveCamera, Quaternion } from "three/src/Three";
import { Quick3DPerspectiveCamera } from "../camera/quick3d-perspective-camera";
import mark from "../../../images/icons/mark.png";
import { Viewer } from "../viewer";

export class AutoAttenuablePointer extends Group {
  private _id: string;

  private _mark: Sprite;
  private _material: SpriteMaterial;
  private _pointName: string;

  private _textMesh: Sprite;
  private _font: Font;
  private _textGeometry: TextGeometry;
  private _textMaterial: SpriteMaterial;

  constructor(id: string, name: string, viewer: Viewer) {
    //, canvas: HTMLCanvasElement
    super();
    this._id = id;
    // mark
    this._material = new SpriteMaterial({
      color: "#FF0000",
      map: new TextureLoader().load(mark, () => { viewer.updateRenderer(); }),
      sizeAttenuation: false,
      depthTest: false,
    });
    this._material.map.minFilter = LinearFilter;
    this._mark = new Sprite(this._material);
    this.add(this._mark);

    this._pointName = name ? name : "";
    /* use text geometry */
    this._font = new Font(font);
    this._textGeometry = new TextGeometry(name, {
      font: this._font,
      size: PICKPOINT_TEXT_SIZE,
      height: PICKPOINT_TEXT_HEIGHT,
    });
    this._textMaterial = new SpriteMaterial({
      color: "#FF0000",
      sizeAttenuation: false,
      depthTest: false,
    });
    this._textMesh = new Sprite(this._textMaterial);
    this._textMesh.geometry = this._textGeometry;
    this.add(this._textMesh);
    const markSize = new Vector3();
    const bbox = new Box3();
    bbox.setFromObject(this._mark);
    bbox.getSize(markSize);
    // this._textMesh.position.copy(this._mark.position);
    // this._textMesh.position.y = this._mark.position.y + 0.2;
    // this._textMesh.position.x = this._mark.position.x + 0.2;

    this._mark.onBeforeRender = function (
      _ifcRenderer: WebGLRenderer,
      _nonClippingScene: Scene,
      camera: Camera
    ): void {
      let scale = 1;
      const windowScale = Math.sqrt(1280 * 720 / (window.screen.width * window.screen.height));
      if (camera instanceof OrthographicCamera) {
        scale = ((camera.right - camera.left) / camera.zoom) * 0.04 * 1.5 * windowScale;
      }
      if (camera instanceof Quick3DPerspectiveCamera) {
        scale = 0.1 * windowScale
      }

      this.scale.set(scale, scale, scale);
      this.updateMatrixWorld();
    };

    this._textMesh.onBeforeRender = function (
      _ifcRenderer: WebGLRenderer,
      _nonClippingScene: Scene,
      camera: Camera
    ): void {
      let scale = 1;
      const windowScale = Math.sqrt(1280 * 720 / (window.screen.width * window.screen.height));
      if (camera instanceof OrthographicCamera) {
        scale = ((camera.right - camera.left) / camera.zoom) * 0.04 * 1.5 * windowScale;
        this.scale.set(scale, scale, scale);
        this.position.set(scale / 5, scale / 5, 0);
      }
      if (camera instanceof Quick3DPerspectiveCamera) {
        scale = 0.1 * windowScale;
        this.scale.set(scale, scale, scale);
        this.position.set(scale * 2, scale * 2, 0);
      }
      this.updateMatrixWorld();
    };
  }

  dispose() {
    this.children.forEach((c) => {
      c.removeFromParent();
      c = undefined;
    });
    this.removeFromParent();
    // this = undefined;
  }

  public getId(): string {
    return this._id;
  }

  public getPickPointGroup(): Group {
    return this;
  }

  public setPosition(position: Vector3, offset: Vector3 = new Vector3()): void {
    this.position.set(
      position.x - offset.x,
      position.y - offset.y,
      position.z - offset.z
    );
  }

  public setName(name: string): void {
    this._textMesh.geometry = new TextGeometry(name, {
      font: this._font,
      size: PICKPOINT_TEXT_SIZE,
      height: PICKPOINT_TEXT_HEIGHT,
    });
  }

  public setVisibility(visibility: boolean) {
    this.visible = visibility;
  }
}
